import type { NitroFetchRequest } from 'nitropack'
import { useFetch } from 'nuxt/app'

export function $superFetch<T = unknown,
  R extends NitroFetchRequest = NitroFetchRequest> (
  url: Parameters<typeof $fetch<T, R>>[0],
  options?: Partial<Parameters<typeof $fetch<T, R>>[1]>,
) {
  return $fetch<T, R>(url, {
    ...options,
    parseResponse: superjsonParse,
  })
}

export function useSuperFetch<T> (
  ...[url, options]: Parameters<typeof useFetch<T>>
): ReturnType<typeof useFetch<T>> {
  return useFetch<T>(url, {
    ...options,
    parseResponse: superjsonParse,
  })
}
